var _defs, _circle, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.751,
    height: 26.751,
    viewBox: "0 0 26.751 26.751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0f0f0;}.b{fill:#0052b4;}.c{fill:#d80027;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.715 0.715)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.1,100.142a13.2,13.2,0,0,0-2.282,4.609H15.71Z",
    transform: "translate(-8.819 -95.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M376.9,104.752a13.2,13.2,0,0,0-2.282-4.609l-4.609,4.609Z",
    transform: "translate(-351.316 -95.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.819,322.784a13.2,13.2,0,0,0,2.282,4.609l4.609-4.609Z",
    transform: "translate(-8.819 -306.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M327.391,11.1a13.2,13.2,0,0,0-4.609-2.282V15.71Z",
    transform: "translate(-306.537 -8.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M100.142,374.614a13.2,13.2,0,0,0,4.609,2.282v-6.891Z",
    transform: "translate(-95.417 -351.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M104.751,8.819a13.2,13.2,0,0,0-4.609,2.282l4.609,4.609Z",
    transform: "translate(-95.417 -8.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M322.783,376.9a13.2,13.2,0,0,0,4.609-2.282l-4.609-4.609Z",
    transform: "translate(-306.538 -351.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M370.005,322.784l4.609,4.609a13.2,13.2,0,0,0,2.282-4.609Z",
    transform: "translate(-351.316 -306.539)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.259 0.259)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M26.38,11.518H14.974V.112a13.368,13.368,0,0,0-3.456,0V11.518H.112a13.367,13.367,0,0,0,0,3.455H11.518V26.38a13.368,13.368,0,0,0,3.456,0V14.974H26.38a13.368,13.368,0,0,0,0-3.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M322.783,322.783h0l5.911,5.911q.408-.408.779-.85l-5.061-5.06h-1.629Z",
    transform: "translate(-306.081 -306.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M80.891,322.784h0l-5.911,5.911q.408.408.85.779l5.061-5.061Z",
    transform: "translate(-71.1 -306.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M66.622,80.891h0L60.712,74.98q-.408.408-.779.85l5.061,5.061h1.629Z",
    transform: "translate(-56.832 -71.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M322.783,66.623h0l5.911-5.911q-.408-.408-.85-.779l-5.061,5.061Z",
    transform: "translate(-306.081 -56.833)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEng);
export default __webpack_public_path__ + "static/media/eng.248a63c03c565429607c79a5faeb5bbd.svg";
export { ForwardRef as ReactComponent };